import {
  Box,
  Stack,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { SalesforceIntegrationButton } from "../components/SalesforceIntegrationButton";
import { useSalesforcePageContext } from "../contexts/useSalesforcePageContext";

export const SalesforceWelcomeView: React.FC = () => {
  const { showBackdrop } = useSalesforcePageContext();

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        width="100%"
        height="100%"
        paddingTop={25}
        sx={{
          backgroundColor: "#f3f6f7",
        }}
      >
        <Stack display="flex" flexDirection="column" gap={6}>
          <img
            height="80px"
            alt="Salesforce Logo"
            src="https://static.hginsights.com/icons/salesforce_logo.svg"
          />
          <Stack gap={3} textAlign="center">
            <Typography
              data-testid="salesforce-welcome-title"
              id="title"
              fontWeight={500}
              fontSize="24px"
            >
              Welcome to HG Insights for Salesforce
            </Typography>
            <Typography
              variant="body1"
              maxWidth="900px"
              fontWeight="500"
              fontSize="16px"
            >
              An unprecedented view into global industries, markets, and
              companies allowing you to identify the most valuable opportunities
              and build strategies to accelerate growth.
            </Typography>
          </Stack>
          <Box textAlign="center">
            <SalesforceIntegrationButton />
          </Box>
        </Stack>
      </Box>

      {/* Backdrop during integration creation and navigation */}
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          flexDirection: "column",
          gap: 2,
        }}
        open={showBackdrop}
      >
        <CircularProgress color="inherit" size={60} />
      </Backdrop>
    </>
  );
};
